import {
  COMMON_QUERY_CONFIG,
  COMMON_QUERY_RULES_CONFIG,
  COMMON_RELATED_OPINION_QUERY_RULES_CONFIG,
  COMMON_VIDEO_QUERY_RULES_CONFIG,
  ruleNewsPlus
} from './shared/configs';

enum SECTION_ENUM {
  TECH = 'Technology',
  AI = 'Artificial Intelligence',
  PERSONAL_TECHNOLOGY = 'Personal Technology',
  BIOTECH = 'Biotech',
  DEFAULT = 'Default',
  RELATED_OPINION = 'Related Opinion',
  VIDEO = 'Video'
}

const MAIN = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    not: [...(COMMON_QUERY_RULES_CONFIG.not ?? []), ruleNewsPlus],
    or: [
      { terms: { key: 'DJEThing', value: ['tech'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['tech/ai'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['tech/personal-tech'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['tech/biotech'] } }
    ]
  }
};

const AI = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['tech/ai'] } }]
  }
};

const PERSONAL_TECHNOLOGY = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['tech/personal-tech'] } }]
  }
};

const BIOTECH = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['tech/biotech'] } }]
  }
};

const RELATED_OPINION = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_RELATED_OPINION_QUERY_RULES_CONFIG,
    and: [
      ...(COMMON_RELATED_OPINION_QUERY_RULES_CONFIG.and ?? []),
      {
        codes_with_significance: {
          key: 'djething',
          significance: ['significant'],
          value: ['tech', 'tech/ai', 'tech/personal-tech', 'tech/biotech']
        }
      }
    ],
    or: [],
    not: []
  }
};

const VIDEO = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_VIDEO_QUERY_RULES_CONFIG,
    or: [{ term: { key: 'DJEThing', value: 'tech' } }, { prefix: { key: 'DJEThing', value: 'tech/' } }],
    not: []
  }
};

export { MAIN, SECTION_ENUM, AI, PERSONAL_TECHNOLOGY, BIOTECH, RELATED_OPINION, VIDEO };
